<div
    [class.chat-contact-window-page]="(isPage$ | async) === true"
    class="chat-contact-window mocha-chat chatbot"
    [class.open]="selectChatOpened$ | async"
>
    <div class="itx-chat-wrapper">
        <!-- Cabecera -->
        <div class="chatbot-header" (click)="close()">
            <svg-icon class="is-invert pr-16 ml-16" src="chat"></svg-icon>
            <span>{{ 'dev.chatbot.onlineShoppingAssistant' | translate }}</span>
            <svg-icon [hidden]="(isPage$ | async) === true" class="url-icon-close is-invert" src="close"></svg-icon>
        </div>

        <!-- Iframe -->
        <div id="chat-container" class="contenido h-100">
            <div class="itx-chat-client">
                <div class="itx-chat-window"></div>
                <loading *ngIf="(loading$ | async) === true"></loading>
                <div class="itx-chat-selector-window align-center" [hidden]="(showSelector$ | async) === false">
                    <!-- <span class="itx-chat-title"></span> -->
                    <select class="itx-chat-selector mb-16">
                        {{
                            'dev.mocachat.selectlanguage' | translate
                        }}
                    </select>
                    <button class="itx-chat-init-button btn btn-primary btn--medium">
                        {{ 'dev.mocachat.startchat' | translate }}
                    </button>
                </div>
                <div class="itx-chat-footer">
                    <div class="itx-chat-button-attachment">
                        <button type="button" class="itx-attachment-button">
                            <svg-icon src="upload" class="is-invert"></svg-icon>
                        </button>
                        <input [hidden]="true" type="file" class="itx-input-file" />
                    </div>
                    <div class="itx-chat-input-window" [class.textareaPage]="(isPage$ | async) === true">
                        <textarea rows="1" class="itx-chat-input w-100" [placeholder]="'dev.mocachat.writemessage' | translate"></textarea>
                    </div>
                    <div class="itx-chat-button-window">
                        <button type="button" class="itx-chat-button btn">
                            <svg-icon src="arrow-right" class="is-invert"></svg-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
